/* @flow weak */
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';
import TranslationActions from 'actions/TranslationActions';

/* Component to translate text to any language
 *
 * getInitialState() {
 *   return {
 *     lang: 'en'
 *   };
 * },
 *
 * componentDidMount() {
 *   setTimeout(() => this.setState({lang: 'es'}, 2000)); // translate to spanish
 *   setTimeout(() => this.setState({lang: 'en'}, 4000)); // translate back to english
 * },
 *
 * onLanguageChanged(lang) {
 *   console.log('translated to ' + lang)
 * }
 *
 * render() {
 *   return (
 *     <TranslatableText
 *       text="hello"
 *       lang={this.state.lang}
 *       onLanguageChanged={this.onLanguageChanged}
 *     />
 *   );
 * }
 */
class TranslatableText extends React.Component {
  static propTypes = {
    language: React.PropTypes.string,
    text: React.PropTypes.string.isRequired,
    onLanguageChanged: React.PropTypes.func,
  };

  static defaultProps = {
    language: null,
  };

  state = {
    text: this.props.text,
    cache: {},
  };

  componentDidMount() {
    this.addToCache(this.props.language, this.props.text);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.language !== nextProps.language) {
      this.translateTo(nextProps.language);
    }
  }

  addToCache = (locale, text) => {
    const { cache } = this.state;
    cache[locale] = text;
    this.setState({ cache });
  };

  translateTo = (locale) => {
    const onTranslationSuccess = (response) => {
      this.setState({ text: response.translation });

      if (this.props.onLanguageChanged) {
        this.props.onLanguageChanged(locale);
      }

      return response;
    };

    const addToCache = (response) => {
      this.addToCache(locale, response.translation);
    };

    if (this.state.cache[locale]) {
      this.setState({ text: this.state.cache[locale] });

      if (this.props.onLanguageChanged) {
        this.props.onLanguageChanged(locale);
      }
    } else {
      TranslationActions
        .translate(this.props.text, locale)
        .then(onTranslationSuccess)
        .then(addToCache)
        .catch(e => console.error('TranslationActions.translate failed', e));
    }
  };

  render() {
    const entities = [].concat(
      TextEntities.parseEmoji(this.state.text),
      TextEntities.parseNewlines(this.state.text),
      TextEntities.parseLeadingWhitespace(this.state.text),
      TextEntities.parseUrls(this.state.text)
    );

    return (
      <div className="TranslatableText">
        <TextWithEntities text={this.state.text} entities={entities} />
      </div>
    );
  }
}

export default TranslatableText;



// WEBPACK FOOTER //
// ./src/chat/components/TranslatableText.jsx